
<template>
  <div>
    <div v-on:dblclick="editing = true">
      <span v-if="editing">
        <input v-model="itemEdit" type="text">
        <span style="white-space: nowrap;">
          <button class="btn--small" v-on:click="saveItemChanges()">Save</button>
          <button class="btn--small" v-on:click="cancelEdit()">x</button>
        </span>
      </span>

      <span v-else class="plain-property">
        {{ itemProperty || '-' }}
      </span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.plain-property {
  display: inline-block;
  min-width: 10px;
}
</style>

<script>
import * as db from '@/libs/db.js';
import { ItemAdapter } from '@/libs/Item.js';

export default {
  props: ["item", "propertyPath"],
  store: db.store,
  data() {
    return {
      itemEdit: null,
      editing: false,
    };
  },
  computed: {
    itemProperty() {
      return this.getObjectProperty(this.item, this.propertyPath);
    },
  },
  methods: {
    getObjectProperty(item, propertyPath) {
      let itemPath = item;
      for (let propPath of propertyPath) {
        itemPath = itemPath[propPath];
      }
      return itemPath;
    },
    async saveItemChanges() {
      // let itemCopy = Object.assign({}, this.item);
      const itemCopy = ItemAdapter.inflate(ItemAdapter.flatten(this.item));

      let itemPath = this.getObjectProperty(itemCopy, this.propertyPath.slice(0, -1));
      itemPath[this.propertyPath[this.propertyPath.length - 1]] = this.itemEdit;

      await this.$store.dispatch('putItem', itemCopy);

      this.editing = false;
    },
    cancelEdit() {
      this.editing = false;
      this.itemEdit = this.itemProperty;
    },
  },
  mounted() {
    this.itemEdit = this.itemProperty;
  },
}
</script>